/**
 * The message an OAuth consent popup posts back to the window that opened it.
 *
 * Two pages can be the last one in a popup, and both must speak this exact
 * contract or a successful connection looks like nothing happening:
 *  - the API's own callback page (`backend/src/services/accounts/oauth-routes.ts`),
 *    which is where the code is exchanged;
 *  - this app's `/oauth/callback` route, when the provider's redirect URI points
 *    at the back-office rather than at the API.
 *
 * `useOAuthPopup` filters on `source`, which is why the message can be posted to
 * `*`: it carries an outcome, never a token.
 */
export const OAUTH_MESSAGE_SOURCE = "heyup-oauth";

export interface OAuthPopupMessage {
  source: typeof OAUTH_MESSAGE_SOURCE;
  success: boolean;
  provider?: string;
  error?: string;
}
